"use client";

import SessionUpdater from "@/app/SessionUpdater";
import PostHogClientProvider from "@/app/PostHogClientProvider";
import WebMcpProvider from "@/components/agent/WebMcpProvider";
import AppDownloadExitIntent from "@/components/common/AppDownloadExitIntent";
import PartnerAttribution from "@/components/partners/PartnerAttribution";

export default function RootClientEffects() {
  return (
    <>
      <PostHogClientProvider />
      <PartnerAttribution />
      <WebMcpProvider />
      <AppDownloadExitIntent />
      <SessionUpdater />
    </>
  );
}
